import { ProductionAuditEventDescriptions } from '@enums/production-audit-event-type.enum';
import { MapperBase } from '../../utilities/mapper-base';
import { AuditResource } from '../resource/audit.resource';
import { ProductionJobAudit } from '../ui/production-job-audit.model';

export class AuditResourceToProductionJobAuditMapper extends MapperBase<AuditResource, ProductionJobAudit> {
    map(source: AuditResource): ProductionJobAudit {
        const ipv4 = source?.ipv4.split(',')[0];
        const description = ProductionAuditEventDescriptions[source?.action] || 'Unknown event type';
        const browserIcon = BrowserIconMap.get(source?.browser) || 'fa-duotone fa-light fa-browser';
        const operatingSystemIcon = OperatingSystemIconMap.get(source?.operatingSystem) || 'fa-regular fa-computer-classic';
        const partIndex = source?.partIndex ?? null;
        const dest: ProductionJobAudit = {
            productionId: source?.productionId,
            caseId: source?.caseId,
            sharedExportId: source?.sharedProductionJobId,
            email: source?.email,
            ipv4,
            browser: source?.browser || 'Unknown',
            browserIcon,
            operatingSystem: source?.operatingSystem || 'Unknown',
            operatingSystemIcon,
            entity: source?.entity,
            action: source?.action,
            description,
            createdAtDateTimeOffset: source?.createdAtDateTimeOffset,
            auditAtDateTimeOffset: source?.auditAtDateTimeOffset,
            partIndex
        };
        return dest;
    }
}

export const BrowserIconMap: Map<string, string> = new Map<string, string>([
    ['Chrome', 'fa-brands fa-chrome'],
    ['Safari', 'fa-brands fa-safari'],
    ['Edge', 'fa-brands fa-edge'],
    ['Firefox', 'fa-brands fa-firefox-browser'],
    ['Opera', 'fa-brands fa-opera'],
    ['unknown', 'fa-duotone fa-light fa-browser'],
]);

export const OperatingSystemIconMap: Map<string, string> = new Map<string, string>([
    ['Windows', 'fa-brands fa-windows'],
    ['Linux', 'fa-brands fa-linux'],
    ['macOS', 'fa-brands fa-apple'],
    ['Android', 'fa-brands fa-andriod'],
    ['iOS', 'fa-duotone fa-light fa-mobile-notch'],
    ['unknown', 'fa-regular fa-computer-classic'],
]);
